import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Pane } from '../../layers';
import { Paragraph } from '../../typography';
import { withTheme } from '../../theme';

var TooltipStateless =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(TooltipStateless, _PureComponent);

  function TooltipStateless() {
    _classCallCheck(this, TooltipStateless);

    return _possibleConstructorReturn(this, _getPrototypeOf(TooltipStateless).apply(this, arguments));
  }

  _createClass(TooltipStateless, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theme = _this$props.theme,
          children = _this$props.children,
          appearance = _this$props.appearance,
          props = _objectWithoutProperties(_this$props, ["theme", "children", "appearance"]);

      var _theme$getTooltipProp = theme.getTooltipProps(appearance),
          color = _theme$getTooltipProp.color,
          themedProps = _objectWithoutProperties(_theme$getTooltipProp, ["color"]);

      var child;

      if (typeof children === 'string') {
        child = React.createElement(Paragraph, {
          color: color,
          size: 400
        }, children);
      } else {
        child = children;
      }

      return React.createElement(Pane, _extends({
        borderRadius: 3,
        paddingX: 8,
        paddingY: 4,
        maxWidth: 240
      }, themedProps, props), child);
    }
  }]);

  return TooltipStateless;
}(PureComponent);

TooltipStateless.displayName = "TooltipStateless";

_defineProperty(TooltipStateless, "propTypes", {
  children: PropTypes.node,

  /**
   * The appearance of the tooltip.
   */
  appearance: PropTypes.oneOf(['default', 'card']).isRequired,

  /**
   * Theme provided by ThemeProvider.
   */
  theme: PropTypes.object.isRequired
});

export default withTheme(TooltipStateless);